// removed by extract-text-webpack-plugin
module.exports = {"copyright-container":"copyright-container","copyright-text":"copyright-text","footer-copyright-title":"footer-copyright-title","footer-description":"footer-description"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-footer/_CopyRight.scss
// module id = ./components/layouts/master/sub-footer/_CopyRight.scss
// module chunks = 0